import React, { createContext, useContext, useState, useCallback } from 'react';
import Toast from './Toast';

interface ToastContextType {
    showToast: (message: string, type?: 'error' | 'success' | 'info', duration?: number) => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [toast, setToast] = useState<{
        message: string;
        type: 'error' | 'success' | 'info';
        duration: number;
    } | null>(null);

    const showToast = useCallback((message: string, type: 'error' | 'success' | 'info' = 'error', duration: number = 3000) => {
        setToast({ message, type, duration });
    }, []);

    const handleClose = useCallback(() => {
        setToast(null);
    }, []);

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}
            {toast && (
                <Toast
                    message={toast.message}
                    type={toast.type}
                    duration={toast.duration}
                    onClose={handleClose}
                />
            )}
        </ToastContext.Provider>
    );
};

export const useToast = () => {
    const context = useContext(ToastContext);
    if (context === undefined) {
        throw new Error('useToast must be used within a ToastProvider');
    }
    return context;
}; 